import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

const PROJECT_ID = '93dbf476-f988-4d84-82fd-17b086437a0c';
const SHOWSTOPPER_ON_MYLOUNGE_CONTROL = 'control_getinspired_off';
const SHOWSTOPPER_ON_MYLOUNGE_VARIANT = 'variant_getinspired_on';

export const useShowstopper = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));

    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === SHOWSTOPPER_ON_MYLOUNGE_VARIANT;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [SHOWSTOPPER_ON_MYLOUNGE_CONTROL, SHOWSTOPPER_ON_MYLOUNGE_VARIANT],
});
